import { render, staticRenderFns } from "./ServiceAssessmentAnatomicalMark.vue?vue&type=template&id=0a241b98&scoped=true"
import script from "./ServiceAssessmentAnatomicalMark.vue?vue&type=script&lang=js"
export * from "./ServiceAssessmentAnatomicalMark.vue?vue&type=script&lang=js"
import style0 from "./ServiceAssessmentAnatomicalMark.vue?vue&type=style&index=0&id=0a241b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a241b98",
  null
  
)

export default component.exports